/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSupplierInput } from '../models/CreateSupplierInput';
import type { PagedSupplierListSchema } from '../models/PagedSupplierListSchema';
import type { SupplierSchema } from '../models/SupplierSchema';
import type { UpdateSupplierInputSchema } from '../models/UpdateSupplierInputSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SuppliersApi {
    /**
     * Get Supplier List
     * Get list of suppliers
     * @returns PagedSupplierListSchema OK
     * @throws ApiError
     */
    public static warehouseGetSupplierListGet({
        name,
        description,
        identificationNumberOfPerson,
        taxIdentificationNumber,
        limit = 100,
        offset,
    }: {
        name?: (string | null),
        description?: (string | null),
        identificationNumberOfPerson?: (string | null),
        taxIdentificationNumber?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedSupplierListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/suppliers/',
            query: {
                'name': name,
                'description': description,
                'identification_number_of_person': identificationNumberOfPerson,
                'tax_identification_number': taxIdentificationNumber,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Supplier
     * Create new Supplier
     * @returns SupplierSchema Created
     * @throws ApiError
     */
    public static warehouseCreateSupplierPost({
        requestBody,
    }: {
        requestBody: CreateSupplierInput,
    }): CancelablePromise<SupplierSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/suppliers/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update Supplier
     * Update Supplier
     * @returns SupplierSchema OK
     * @throws ApiError
     */
    public static warehouseUpdateSupplierPut({
        supplierId,
        requestBody,
    }: {
        supplierId: string,
        requestBody: UpdateSupplierInputSchema,
    }): CancelablePromise<SupplierSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/suppliers/{supplier_id}/',
            path: {
                'supplier_id': supplierId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Supplier Item
     * Delete Supplier
     * @returns void
     * @throws ApiError
     */
    public static warehouseDeleteSupplierItemDelete({
        supplierId,
    }: {
        supplierId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/suppliers/{supplier_id}/',
            path: {
                'supplier_id': supplierId,
            },
        });
    }
    /**
     * Get Supplier
     * Get Supplier
     * @returns SupplierSchema OK
     * @throws ApiError
     */
    public static warehouseGetSupplierGet({
        supplierId,
    }: {
        supplierId: string,
    }): CancelablePromise<SupplierSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/suppliers/{supplier_id}/',
            path: {
                'supplier_id': supplierId,
            },
        });
    }
}
